import { postData } from "../../shared/services/service";

export const supportContactReasons = [
  "Report an issue",
  "Report a bug",
  "Propose new functionality",
  "Request help",
  "General matters",
] as const;

export type SupportContactReason = (typeof supportContactReasons)[number];

interface SendSupportContactPayload {
  reason: SupportContactReason;
  message: string;
}

export const sendSupportContact = async (payload: SendSupportContactPayload) => {
  return postData("support/contact", payload);
};
